import React, { useContext } from 'react';
import styled from 'styled-components';
import { RevenueCalendarContext } from '../context/RevenueCalendarProvider';
import { RevenueProvider } from '../context/RevenueProvider';
import CalendarRevenue from './CalendarRevenue';
import CalendarWeeklyRevenue from './CalendarWeeklyRevenue';
import ConcessionRevenue from './ConcessionRevenue'
import Model from '../../components/UI/Modal/Model';
import CustomModal from '../../components/UI/Modal/CustomModal';
import IdleTimerContainer from '../../containers/IdleTimer/IdleTimerContainer';
import {RequestStatus} from '../../common/const/RequestStatus'
import './index.css';

function RevenueContainer(props) {

    const { revenueDate, minDate, maxDate, sessionTimeoutLimit, idleTimeoutLimit, isError,
        isSuccessfulSubmitted, errorMessage, showModel, showInstructions, modelHeaderTitle, selectedContractCodeValue,
        isFileImportedSuccessfully, isDateChanged , statusWiseRevenueDates, changeReqNumber, unblockFromDate,
        requestStatus, revenueDateHandler, resetSubmittedAndErrorFlags, handleConfirmationYesClick, weeklyStartDate,
        weeklyEndDate, setWeeklyStartDate, setWeeklyEndDate , isMonthlyRevenueSubmitted, contractCodeList,
        weeklyDateHandler } = useContext(RevenueCalendarContext);
    
    const Separator = styled.div`
    clear: both;
    position: relative;
    margin: .01rem 0;
    background-color: #ddd;
    height: 2px;
    `;
    
    return (
        <>
            <div className="sidebar-bottomcontent-container-col">
                <div style={{height:"49.8vh"}}><></></div>     
                {!props.isWeekly && revenueDate && <div>
                    <Separator />
                    <CalendarRevenue revenueDate={revenueDate}
                        minDate={minDate}
                        maxDate={maxDate}
                        isDateChanged = {isDateChanged}
                        statusWiseRevenueDates={statusWiseRevenueDates} 
                        onDateChange={revenueDateHandler}
                    />
                </div>}
                {props.isWeekly && weeklyStartDate && weeklyEndDate && <div>
                    <Separator />
                    <CalendarWeeklyRevenue weeklyStartDate={weeklyStartDate}
                        weeklyEndDate={weeklyEndDate}
                        minDate={minDate}
                        maxDate={maxDate}
                        isDateChanged = {isDateChanged}
                        statusWiseRevenueDates={statusWiseRevenueDates} 
                        onDateChange={weeklyDateHandler}
                        setWeeklyStartDate={setWeeklyStartDate}
                        setWeeklyEndDate={setWeeklyEndDate}
                    />
                </div>}
            </div>
            <div className="sidebar-bottomcontent-container-next-col">
                <div className="main-contents">
                    <div className="main-content"> 
                    <RevenueProvider  BusinessPartnerCode={props.BusinessPartnerCode} 
                                    isLogout={props.isLogout}   
                                    onLogoutClick={props.onLogoutClick}
                                    clearSessionData={props.clearSessionData}
                                    UserId={props.UserId}
                                    isWeekly={props.isWeekly}>
                            <ConcessionRevenue BusinessPartnerCode={props.BusinessPartnerCode} 
                                isLogout={props.isLogout}   
                                onLogoutClick={props.onLogoutClick}
                                clearSessionData={props.clearSessionData}
                                isWeekly={props.isWeekly}
                            />                                        
                    </RevenueProvider>                                        
                    </div>
                </div>
            </div>
            { showModel && (!requestStatus || requestStatus <=RequestStatus.Inprogress.id) && 
                <Model showModel={showModel}
                    onHideHandler={resetSubmittedAndErrorFlags}
                    showHeader={showModel}
                    showInstructions={showInstructions}
                    headerTitle={modelHeaderTitle}
                    showSuccess={isSuccessfulSubmitted || isFileImportedSuccessfully}
                    successMessage={isSuccessfulSubmitted ? changeReqNumber ? "cr_submitted_successfully" : "revsubmitted" 
                        : isFileImportedSuccessfully ? "fileimportedsuccessfully" : ""}
                    successFullMessage ={isMonthlyRevenueSubmitted ? "revmonthlysubmitted" : ""}
                    showError={isError}
                    errorMessage={errorMessage}
                    additionInfo={changeReqNumber}
                    handleConfirmationYesClick={handleConfirmationYesClick}
                    isBusinessPartner = {true} />
            }
            { showModel && (requestStatus && requestStatus > RequestStatus.Inprogress.id) && 
                <CustomModal showModel={showModel}
                    onHideHandler={resetSubmittedAndErrorFlags}
                    Status={requestStatus}
                    BusinessPartnerCode={props.BusinessPartnerCode} 
					selectedAttentionMessage ={isMonthlyRevenueSubmitted ? "attention" : ""}
                    selectedSuccessFullMessage ={isMonthlyRevenueSubmitted ? "revmonthlybulksubmitted" : ""}
					isMonthlyRevenueSubmitted={isMonthlyRevenueSubmitted}
                    contractCodeListDisplay={contractCodeList}
                    contractCode={selectedContractCodeValue}
                    RevenueDate={requestStatus > 3 ? unblockFromDate : revenueDate}
                    ErrorMessage={errorMessage}
                    isWeekly={true}
                />
            }
            {sessionTimeoutLimit && idleTimeoutLimit && <IdleTimerContainer idleTimeoutLimit={1000 * idleTimeoutLimit}
                sessionTimeoutLimit={1000 * sessionTimeoutLimit}
                logout={props.onLogoutClick} />}
                        
        </>
    );
}

export default RevenueContainer;